<template>
  <vbt-dialog
    v-model="dialog"
    :disable-submit-btn="!selectedJobs.length"
    title="Jobs for processing"
    submit-btn-name="Process"
    width="600px"
    @submit="submitProcessing"
  >
    <v-layout>
      Machine:
      <strong class="ml-1">
        {{ machine }}
      </strong>
    </v-layout>

    <v-layout>
      Basket ID:
      <strong class="ml-1">
        <router-link
          :to="{
            name: 'basket',
            params: { id: basketId },
            query: { suffix },
          }"
          class="blue--text"
          target="_blank"
        >
          {{ basketId }}
        </router-link>
      </strong>
    </v-layout>

    <vbt-table
      :headers="headers"
      :items="jobs"
      :page-size="jobs.length"
    >
      <template #checkboxes="{ item }">
        <v-checkbox
          v-if="item._selectable"
          :input-value="selectedJobs.includes(item.id)"
          :color="selectedJobs.includes(item.id) ? 'success' : ''"
          class="vbt-hide-form-control-details"
          @click="refreshSelectedJobs(item.id)"
        />
      </template>

      <template #outerId="{ item: { outerId, link } }">
        <pb-outer-link :link="link">
          {{ outerId }}
        </pb-outer-link>
      </template>

      <template #actions="{ item: { id } }">
        <v-blacker-tooltip top>
          <template #activator="{ on }">
            <v-blacker-button
              :to="{
                name: 'job',
                params: { id },
                query: { suffix },
              }"
              icon
              icon-name="remove_red_eye"
              target="_blank"
              color="info"
              small
              v-on="on"
            />
          </template>
          {{ `Job ${id} details` }}
        </v-blacker-tooltip>
      </template>
    </vbt-table>
  </vbt-dialog>
</template>

<script>
import { mapState } from 'vuex';

import { LOCATIONS_NAMESPACE } from '@store/modules/locations.types';

import { wrapToLoadingFn } from '@helpers';

import { DashboardApiService } from '../../_services/dashboard.api.service';

const headers = Object.freeze([
  { name: '', value: 'checkboxes', width: '1%' },
  { text: 'Outer ID', value: 'outerId' },
  { text: 'State', value: 'state' },
  { text: '', value: 'actions', width: '5%' },
]);

export default {
  name: 'PbDashboardQueuesProcessingJobsReplacer',

  data() {
    return {
      dialog: false,
      basketId: 0,
      machine: '',
      jobs: [],

      selectedJobs: [],

      headers,
    };
  },

  computed: {
    ...mapState(LOCATIONS_NAMESPACE, ['suffix']),
  },

  methods: {
    $_openDialog(basketId, machine) {
      this.wrapToLoadingFn({
        req: DashboardApiService.getBasketJobs.bind({}, {
          suffix: this.suffix,
          basketId,
        }),
        fullscreenLoadingSpinner: true,
        onSuccess: (r) => {
          this.jobs = r
            .map(job => ({
              ...job,
              _selected: (job.state || '').toLowerCase() === 'queued',
              _selectable: (job.state || '').toLowerCase() === 'queued',
            }))
            .sort(({ state }) => ((state || '').toLowerCase() === 'queued' ? -1 : 1));

          this.selectedJobs = this.jobs
            .filter(({ _selected }) => _selected)
            .map(({ id }) => id);

          this.basketId = basketId;
          this.machine = machine;
          this.dialog = true;
        },
      });
    },

    refreshSelectedJobs(id) {
      if (this.selectedJobs.includes(id)) {
        this.selectedJobs.splice(this.selectedJobs.indexOf(id), 1);
      } else {
        this.selectedJobs.push(id);
      }
    },

    submitProcessing() {
      const queuedJobsCount = this.jobs
        .filter(({ state }) => (state || '').toLowerCase() === 'queued')
        .length;
      const isAllQueuedJobsSelected = queuedJobsCount === this.selectedJobs.length;

      this.$emit('process', {
        jobs: isAllQueuedJobsSelected ? null : this.selectedJobs,
        basketId: this.basketId,
        machine: this.machine,
        _closeProcessDialog: () => {
          this.dialog = false;
        },
      });
    },

    wrapToLoadingFn,
  },
};
</script>
